var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfileIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "perm_identity_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/action/perm_identity_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.99998 3.33337C8.15831 3.33337 6.66665 4.82504 6.66665 6.66671C6.66665 8.50837 8.15831 10 9.99998 10C11.8416 10 13.3333 8.50837 13.3333 6.66671C13.3333 4.82504 11.8416 3.33337 9.99998 3.33337ZM11.6666 6.66671C11.6666 5.75004 10.9166 5.00004 9.99998 5.00004C9.08331 5.00004 8.33331 5.75004 8.33331 6.66671C8.33331 7.58337 9.08331 8.33337 9.99998 8.33337C10.9166 8.33337 11.6666 7.58337 11.6666 6.66671ZM15 14.1667C14.8333 13.575 12.25 12.5 9.99998 12.5C7.74998 12.5 5.16665 13.575 4.99998 14.175V15H15V14.1667ZM3.33331 14.1667C3.33331 11.95 7.77498 10.8334 9.99998 10.8334C12.225 10.8334 16.6666 11.95 16.6666 14.1667V16.6667H3.33331V14.1667Z",
  fill: "#4E6072"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile-icon.0ab16394.svg";
export { ForwardRef as ReactComponent };